module.exports = __webpack_public_path__ + "img/rn.761c83b8.svg";